(() => {
  const pad = (value) => String(value).padStart(2, '0');
  const update = (card) => {
    const target = new Date(card.dataset.mvaCountdown).getTime();
    const distance = Math.max(0, target - Date.now());
    const values = {
      days: Math.floor(distance / 86400000),
      hours: Math.floor((distance / 3600000) % 24),
      minutes: Math.floor((distance / 60000) % 60),
      seconds: Math.floor((distance / 1000) % 60)
    };
    Object.entries(values).forEach(([key, value]) => {
      const node = card.querySelector(`[data-${key}]`);
      if (node) node.textContent = pad(value);
    });
  };
  const init = () => document.querySelectorAll('[data-mva-countdown]').forEach((card) => {
    update(card);
    if (!card.dataset.timerStarted) {
      card.dataset.timerStarted = 'true';
      setInterval(() => update(card), 1000);
    }
  });
  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  init();
})();
